import { parseUserSettings } from '../../chunk-EHPC6J6S.mjs';
import '../../chunk-UJBTIEC5.mjs';
import { useRequest } from '../../chunk-Q45WUXHF.mjs';
import '../../chunk-F2DE7PYR.mjs';
import '../../chunk-YJXGQ4TA.mjs';
import '../../chunk-VGNWDLIO.mjs';
import '../../chunk-OTOFLJUZ.mjs';
import '../../chunk-J4IY6DLG.mjs';
import '../../chunk-PAEKLEX5.mjs';
import '../../chunk-FKQPHPFM.mjs';
import '../../chunk-RJ6UFOF4.mjs';
import '../../chunk-XKXEE4JA.mjs';
import '../../chunk-K3UDKV2P.mjs';
import '../../chunk-2AVUNXAY.mjs';
import '../../chunk-XOI4VJKO.mjs';
import '../../chunk-LXZM66LA.mjs';
import '../../chunk-U2EKEPPW.mjs';
import '../../chunk-KTM5ANUO.mjs';
import { graphql } from '../../chunk-NWN55YVG.mjs';
import '../../chunk-Z2OBPTDA.mjs';
import '../../chunk-4U7ZT42S.mjs';

// src/user-settings/query-hooks/index.ts
var userSettingsQuery = graphql(
  /* GraphQL */
  `
  query GetUserSettings {
    user_settings {
      data
    }
  }
`
);
var useLoadUserSettings = (props) => {
  var _a;
  const { getAccessToken } = props;
  const { data, isLoading, error } = useRequest({
    queryKey: ["user-settings"],
    getAccessToken,
    document: userSettingsQuery
  });
  const settings = !isLoading && data ? parseUserSettings((_a = data.user_settings[0]) == null ? void 0 : _a.data) : null;
  return { settings, isLoading, error };
};

export { useLoadUserSettings };
//# sourceMappingURL=index.mjs.map
//# sourceMappingURL=index.mjs.map